import { initConstants } from "features/telegram/constants.ts";
import { initTelegramWebApp } from "features/telegram/initTelegramWebApp.ts";
import { initApp } from "bootstrap.tsx";

const startMockApi = async () => {
  if (import.meta.env.VITE_APP_MOCK_API !== "true") return;
  const { startMockServiceWorker } = await import("mocks/browser");
  await startMockServiceWorker();
};

(async () => {
  await startMockApi();
  await initConstants();
  initTelegramWebApp();
  initApp();
})();
